export enum DocumentType {
  UNKNOWN = "Unknown",
  IVF = "IvfMedicalRecordsConsentForm",
  PREGNANCY = "PregnancyMedicalRecordsConsentForm",
  DOULA = "DoulaAttestationForm",
  ART = "ArtMedicalRecordsConsentForm",
  PRESERVATION = "FertilityPreservationConsentForm"
}

export enum DocumentAction {
  UNKNOWN = "UNKNOWN",
  SKIPPED = "SKIPPED",
  SIGNED = "SIGNED",
  DECLINED = "DECLINED",
  PRESENTED = "PRESENTED"
}

export type DocumentStatus = {
  documentType: DocumentType
  documentAction: DocumentAction
}
